/**
 * Table Of Content
 *
 *  0. On ready // On Load
 *  1. Detect Os
 *  2. getScrollbarWidth
 **/

jQuery(function ($) {
  ("use strict");

  // Fallback for globalAjax if not defined
  if (typeof globalAjax === "undefined") {
    window.globalAjax = {
      ajaxurl: window.location.href,
      nonce: "fallback-nonce",
    };
    console.warn("globalAjax not found, using fallback values");
  }

  /*-----------------------------------------------------------------------------------*/
  /*  0. On ready // On Load
/*-----------------------------------------------------------------------------------*/
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  $(window).scrollTop(0);

  var pageUrl = window.location.href,
    pageUrl_no_protocol = location.host + location.pathname,
    body = document.body,
    bodyPosition = 0,
    wrapper = document.getElementById("wrapper"),
    menu_opened = false;

  var _getScrollbarWidth, vh, _getMenuPos, _html_height, _bordered2;

  var userAgent =
    window.navigator.userAgent.toLowerCase() ||
    navigator.userAgent.toLowerCase() ||
    navigator.vendor.toLowerCase() ||
    window.opera.toLowerCase();

  if (
    userAgent.indexOf("FBAN") > -1 ||
    userAgent.indexOf("FBAV") > -1 ||
    userAgent.indexOf("fban") > -1 ||
    userAgent.indexOf("fbav") > -1 ||
    userAgent.indexOf("instagram") > -1
  ) {
    $("body").addClass("in-app-browser");
    logoAnimation();
  } else {
    detect_os();
  }

  // Create the measurement node
  var scrollDiv = document.createElement("div");
  scrollDiv.className = "scrollbar-measure";
  document.body.appendChild(scrollDiv);
  function getScrollbarWidth() {
    if (!$("body").hasClass("menu-opened")) {
      _getScrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth; //(window.innerWidth - document.body.clientWidth);
    }
    return getScrollbarWidth;
  }

  // Get the scrollbar width
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Delete the DIV
  //document.body.removeChild(scrollDiv);

  $(document).keyup(function (e) {
    if (
      (e.key === "Escape" || e.keyCode === 27) &&
      $("body").hasClass("menu-opened")
    ) {
      // escape key maps to keycode `27`
      $(".hamburger:not(.search-clear)").trigger("click");
    }
  });
  $(".modal-backdrop").on("click", function () {
    $(".modal-close").trigger("click");
  });

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll(".needs-validation");
  // Loop over them and prevent submission
  Array.prototype.slice.call(forms).forEach(function (form) {
    form.addEventListener(
      "submit",
      function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false,
    );
  });

  /*-----------------------------------------------------------------------------------*/
  /*  1. Detect Os
/*-----------------------------------------------------------------------------------*/
  function detect_os() {
    var osDetect = "os-default",
      isMobile = "",
      browserDetect = "unknown",
      browserVersion = "0";

    // OS Detection using navigator.userAgent
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;

    if (platform.indexOf("Mac") !== -1) {
      osDetect = "os-mac";
    } else if (platform.indexOf("Win") !== -1) {
      osDetect = "os-windows";
    } else if (platform.indexOf("Linux") !== -1) {
      osDetect = "os-linux";
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      osDetect =
        "os-ios device-" + (/iPad/.test(userAgent) ? "ipad" : "iphone");
    } else if (/Android/.test(userAgent)) {
      osDetect = "os-android";
    } else if (/CrOS/.test(userAgent)) {
      osDetect = "os-chromeos";
    }

    // Browser Detection
    if (
      userAgent.indexOf("Chrome") !== -1 &&
      userAgent.indexOf("Safari") !== -1 &&
      userAgent.indexOf("Edge") === -1
    ) {
      browserDetect = "chrome";
      var match = userAgent.match(/Chrome\/(\d+)/);
      browserVersion = match ? match[1] : "0";
    } else if (userAgent.indexOf("Firefox") !== -1) {
      browserDetect = "firefox";
      var match = userAgent.match(/Firefox\/(\d+)/);
      browserVersion = match ? match[1] : "0";
    } else if (
      userAgent.indexOf("Safari") !== -1 &&
      userAgent.indexOf("Chrome") === -1
    ) {
      browserDetect = "safari";
      var match = userAgent.match(/Version\/(\d+)/);
      browserVersion = match ? match[1] : "0";
    } else if (userAgent.indexOf("Edge") !== -1) {
      browserDetect = "edge";
      var match = userAgent.match(/Edge\/(\d+)/);
      browserVersion = match ? match[1] : "0";
    } else if (
      userAgent.indexOf("MSIE") !== -1 ||
      userAgent.indexOf("Trident") !== -1
    ) {
      browserDetect = "ie";
      var match = userAgent.match(/(?:MSIE |rv:)(\d+)/);
      browserVersion = match ? match[1] : "0";
    }

    // Simple mobile detection
    var isMobileDevice = function () {
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        ) || window.innerWidth <= 768
      );
    };

    var isTabletDevice = function () {
      return (
        /iPad|Android(?=.*\bMobile\b)(?=.*\bSafari\b)/i.test(
          navigator.userAgent,
        ) ||
        (window.innerWidth > 768 && window.innerWidth <= 1024)
      );
    };

    if (isMobileDevice()) {
      isMobile = "is-mobile";
    } else if (isTabletDevice()) {
      isMobile = "is-tablet";
    }
    if (
      navigator.userAgent.match(/Mac/) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2
    ) {
      osDetect = "device-ipad";
    }

    // Get orientation
    var orientation = "portrait";
    if (window.innerWidth > window.innerHeight) {
      orientation = "landscape";
    }

    $("body")
      .addClass(osDetect)
      .addClass(
        "browser-" +
          browserDetect.toLowerCase() +
          " browser-version-" +
          browserVersion +
          " " +
          isMobile +
          " orientation-" +
          orientation,
      );

    // Handle orientation change
    $(window).on("resize", function () {
      var newOrientation =
        window.innerWidth > window.innerHeight ? "landscape" : "portrait";
      $("body")
        .removeClass("orientation-portrait orientation-landscape")
        .addClass("orientation-" + newOrientation);

      global_css_var();
      if ($("body").hasClass("menu-opened")) {
        $(".hamburger:not(.search-clear)").trigger("click");
      }
    });

    logoAnimation();
  }

  window.addEventListener("orientationchange", function (event) {
    if (event.target.screen.orientation.angle == 0) {
      $("body")
        .addClass("orientation-portrait")
        .removeClass("orientation-landscape");
    } else {
      $("body")
        .addClass("orientation-landscape")
        .removeClass("orientation-portrait");
    }
  });

  /*-----------------------------------------------------------------------------------*/
  /*  2. getScrollbarWidth
/*-----------------------------------------------------------------------------------*/
  setTimeout(function () {
    global_css_var();
  }, 100);
  $(window).resize(function () {
    global_css_var();
  });

  function global_css_var() {
    _html_height = $("body").hasClass("modal-open") ? "height: 100vh;" : "";
    vh = window.innerHeight * 0.01;
    getScrollbarWidth();
    _getMenuPos =
      $(".nav-holder .dropdown-holder").length > 0
        ? $(".nav-holder .dropdown-holder").offset().left
        : "0";
    document.documentElement.style.cssText +=
      "--vh: " +
      vh +
      "px; --window-width: " +
      $("header").width() +
      "px; --scrollbar-width: " +
      _getScrollbarWidth +
      "px;  --menu-pos: " +
      _getMenuPos +
      "px; --scroll-y: " +
      window.scrollY +
      "px; " +
      _html_height;
  }

  var bodyLock, htmlLock, scrollPosition_val;
  function enable(scrollPosition) {
    bodyLock = document.getElementsByTagName("body")[0];
    scrollPosition_val = scrollPosition;
    bodyLock.style.overflow = "hidden";
    bodyLock.style.position = "fixed";
    bodyLock.style.top = "-" + scrollPosition + "px";
  }
  function disable(scrollPosition) {
    bodyLock = document.getElementsByTagName("body")[0];
    bodyLock.style.overflow = "";
    bodyLock.style.position = "";
    bodyLock.style.top = "";
    window.scrollTo(0, scrollPosition_val);
  }

  var $el = $(".logo");
  var elHeight = $el.outerHeight();
  var elWidth = $el.outerWidth();

  var $wrapper = $(".footer-content");

  function doResize(event, ui) {
    var scale, origin;
    scale = Math.min(ui.size.width / elWidth, ui.size.height / elHeight);
    $("html").css("--logo-scale", scale);
  }

  var starterData = {
    size: {
      width: $wrapper.width(),
      height: $wrapper.height(),
    },
  };
  doResize(null, starterData);

  /*-----------------------------------------------------------------------------------*/
  /*  3. Page Transition
/*-----------------------------------------------------------------------------------*/

  //pageTransition();

  function pageTransition() {
    var $links = $(
        "a:not([target='_blank']):not([href='#']):not([href*='#']):not([href*='mailto']):not(.scrolling-to-btn):not(.page-numbers):not(.download):not(.page-numbers):not(.prev):not(.next):not(.transition-exclude):not(.url-link):not(.social-btn)",
      ),
      _pageTransition;
    //localStorage.setItem("pagetransition", "true");
    if (typeof Storage !== "undefined") {
      _pageTransition = localStorage.getItem("pagetransition");
    } else {
      _pageTransition = "true";
    }
    if (_pageTransition == "true") {
      localStorage.setItem("pagetransition", "false");
      $(".page-transition").addClass("start");
      setTimeout(function () {
        $(".page-transition").addClass("out");
        setTimeout(function () {
          $("body").addClass("loaded");
        }, 50);
      }, 100);
      setTimeout(function () {
        $(".page-transition").removeClass("first-load out in start");
      }, 670);
    } else {
      $("body").addClass("loaded first-load");
    }
    $links.on("click", function (e) {
      var url = $(this).attr("href"),
        _this = $(this);
      //if(!_this.closest(".euro-header") && !url.includes('#')){
      if ($(window).width() >= 768) {
        redirectFn(e, url);
      } else if (
        $(window).width() < 768 &&
        !$(this).hasClass("dropdown-control")
      ) {
        redirectFn(e, url);
      }
      //}
    });
    function redirectFn(e, url) {
      if (!e.ctrlKey && !e.metaKey) {
        $(".page-transition").removeClass("first-load").addClass("in");
        localStorage.setItem("pagetransition", "true");
        setTimeout(function () {
          window.location = url;
        }, 650);
        localStorage.setItem("pagetransition", "true");
        return false;
      }
    }
  }

  var headRoom_mobile_timeout,
    headRoom_default_timeout,
    _lock_scroll_val = 0,
    _lock_scroll_offset = $(window).width() >= 992 ? 500 : 250,
    _scroll_direction,
    _lock_scroll_trigger = false;
  $(window).scroll(function () {
    _lock_scroll_offset = $(window).width() >= 992 ? 500 : 250;
    if (_scroll_direction > $(window).scrollTop()) {
      if (_lock_scroll_trigger == false) {
        _lock_scroll_val = $(window).scrollTop();
        _lock_scroll_trigger = true;
      } else if (
        _lock_scroll_val - $(window).scrollTop() >
        _lock_scroll_offset
      ) {
        _lock_scroll_trigger = false;
        $(".headroom").addClass("ready-to-lock");
        $("body").addClass("header-lock");
      }
    } else {
      _lock_scroll_trigger = false;
      _lock_scroll_val = 0;
    }
    _scroll_direction = $(window).scrollTop();
  });

  // Custom headroom implementation
  function initCustomHeadroom() {
    var lastScrollTop = 0;
    var scrollThreshold = _lock_scroll_offset;

    $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();
      var $headroom = $(".headroom");

      if (scrollTop > scrollThreshold) {
        if (scrollTop > lastScrollTop) {
          // Scrolling down
          $headroom
            .removeClass("headroom--pinned")
            .addClass("headroom--unpinned");
          $("body").removeClass("header-lock");
          $headroom.removeClass("ready-to-lock");

          if (
            $("body").hasClass("is-mobile") &&
            $("header").hasClass("transparent-header")
          ) {
            headRoom_mobile_timeout = setTimeout(function () {
              $("header").addClass("sticky");
              $headroom.addClass("fixed");
            }, 450);
          } else {
            headRoom_default_timeout = setTimeout(function () {
              $("header").addClass("sticky");
              $headroom.addClass("fixed");
            }, 300);
          }
        } else {
          // Scrolling up
          $headroom
            .removeClass("headroom--unpinned")
            .addClass("headroom--pinned");
          $headroom.removeClass("fixed");
          $("header").removeClass("sticky");
          $("body").removeClass("header-lock");
          $headroom.removeClass("ready-to-lock");

          if ($("body").hasClass("is-mobile")) {
            clearTimeout(headRoom_mobile_timeout);
          } else {
            clearTimeout(headRoom_default_timeout);
          }
        }
      } else {
        // At top
        $headroom.removeClass(
          "fixed ready-to-lock headroom--pinned headroom--unpinned",
        );
        $("header").removeClass("sticky");
        $("body").removeClass("header-lock");

        if ($("body").hasClass("is-mobile")) {
          clearTimeout(headRoom_mobile_timeout);
        } else {
          clearTimeout(headRoom_default_timeout);
        }
      }

      lastScrollTop = scrollTop;
    });
  }

  // Initialize custom headroom
  initCustomHeadroom();

  function logoAnimation() {
    var $overlay = $(".intro-overlay");
    var shouldAnimate =
      $("body").hasClass("we-are-colorlines") || $("body").hasClass("blog");

    if (!$overlay.length || !shouldAnimate) {
      $("body").addClass("loaded");
      if ($overlay.length) {
        $overlay.addClass("is-hidden");
      }
      return;
    }

    // Keep content paintable while the intro overlay animates.
    $("body").addClass("loaded");
    $overlay.removeClass("is-hidden is-out").addClass("is-active");

    setTimeout(function () {
      setTimeout(function () {
        $overlay.addClass("is-out");
        setTimeout(function () {
          $overlay.removeClass("is-active is-out").addClass("is-hidden");
        }, 2000);
      }, 450);
    }, 500);
  }

  /*-----------------------------------------------------------------------------------*/
  /*  4. Navigation
/*-----------------------------------------------------------------------------------*/
  // Hamburger menu is now handled by Drupal behavior in global.js
  // The jQuery handler has been removed to prevent conflicts
  $(".header-search").each(function () {
    var $form = $(this),
      $trigger = $form.find(".header-search-trigger"),
      $input = $form.find("input"),
      $submit = $form.find("button");
    $trigger.on("click", function () {
      $form.toggleClass("active");
      if (!$form.hasClass("active")) {
        $form.addClass("out");
        setTimeout(function () {
          $form.removeClass("out");
        }, 400);
      } else {
        $input.focus();
      }
      return false;
    });
  });

  $(".mobile-search").each(function () {
    var $form = $(this),
      $trigger = $form.find(".header-search-clear"),
      $input = $form.find("input");
    $input.keydown(function (e) {
      if ($input.val().length > 0) {
        $form.addClass("filled");
      } else {
        $form.removeClass("filled");
      }
    });
    $trigger.on("click", function () {
      $input.val("");
      $form.removeClass("filled");
    });
  });

  $(document).keyup(function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      // escape key maps to keycode `27`
      $(".header-search.active .header-search-trigger").trigger("click");
    }
  });

  //$(".share-holder").each(function(){
  $(".share-btn span").on("click", function (e) {
    e.stopPropagation();
    if ($("body").hasClass("is-tablet") || $("body").hasClass("is-mobile")) {
      //console.log('shate btn clicked')
      $(this).parent().toggleClass("hover");
    }
  });
  //});

  $(document).on("click", function (e) {
    var $info = $(".share-btn");
    if (!$info.is(event.target) && !$info.has(event.target).length) {
      if ($("body").hasClass("is-tablet") || $("body").hasClass("is-mobile")) {
        $(".share-btn").removeClass("hover");
      }
    }
  });

  // copyText
  function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).attr("href")).select();
    document.execCommand("copy");
    $temp.remove();
  }

  $(".social-btn.url-link").click(function (e) {
    e.preventDefault();
    let $this = $(this);
    copyToClipboard($this);
    $this.addClass("copied");
    setTimeout(function () {
      $this.removeClass("copied");
    }, 2500);
  });

  $(document).ready(function () {
    if (!$(".menu").hasClass("loaded")) {
      setTimeout(function () {
        $(".menu").addClass("loaded");
      }, 350);
    }
  });

  $(document).keyup(function (e) {
    if (
      (e.key === "Escape" || e.keyCode === 27) &&
      $("body").hasClass("menu-opened")
    ) {
      // escape key maps to keycode `27`
      $(".hamburger:not(.search-clear)").trigger("click");
    }
  });

  function inView(item) {
    let top_of_element = item.offset().top - 100;
    let bottom_of_element = item.offset().top + item.outerHeight() + 150;
    let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    let top_of_screen = $(window).scrollTop();
    if (
      bottom_of_screen > top_of_element &&
      top_of_screen < bottom_of_element
    ) {
      item.addClass("inview-block");
    } else {
      item.removeClass("inview-block");
    }
  }

  var container_width, container_padding;
  function generalWidth() {
    container_width = $("section .container").innerWidth();
    container_padding = ($("section .container").width() - container_width) / 2;
  }

  generalWidth();
  $(window).scroll(function () {
    generalWidth();
  });

  $(document).ready(function () {
    getScrollbarWidth();
    if (
      $("body").hasClass("os-ios") ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i)
    ) {
      setTimeout(function () {
        document
          .querySelector("meta[name=viewport]")
          .setAttribute(
            "content",
            "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
          );
      }, 100);
    }
    $("a, button, select, input[type=submit], input[type=text]")
      .keyup(function () {
        $(this).addClass("focusOutline");
      })
      .blur(function () {
        $(this).removeClass("focusOutline");
      });

    $(".custom-input input").on("keyup change", function () {
      if ($(this).val().trim().length >= 1) {
        $(this).addClass("filled");
      } else {
        $(this).removeClass("filled");
      }
    });

    //console.log('imageslider here js main js')
    if (typeof Swiper !== "undefined") {
      var swiper3 = new Swiper("#ImagesSlider", {
        grabCursor: true,
        effect: "creative",
        speed: 750,
        loop: true,
        loopAdditionalSlides: 5,
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        creativeEffect: {
          prev: {
            translate: ["-50%", 0, -1],
          },
          next: {
            translate: ["calc(100% - 0px)", 0, 0],
          },
        },
      });
    }

    $(".block-issues-carousel").each(function () {
      var $block = $(this),
        $carousel = $block.find(".issues-carousel");

      if (typeof Swiper !== "undefined") {
        var swiper = new Swiper(".issues-carousel", {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: ".block-issues-carousel .swiper-button-next",
            prevEl: ".block-issues-carousel .swiper-button-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: "2",
            },
          },
          on: {
            afterInit: function (swiper) {
              console.log(swiper.slides.length);
              if (swiper.slides.length > 2) {
                $(swiper.$wrapperEl[0])
                  .closest("section")
                  .find(".block-control")
                  .addClass("show-arrows");
              }
            },
          },
        });
      }
    });
  });

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    //console.log('test')
    return (
      elementBottom - $(window).height() * 0.95 > viewportTop &&
      elementTop + $(window).height() * 0.05 < viewportBottom
    );
  };

  // Issues Animation
  /*$(".issues-template-default #content section").each(function(){
  var $this = $(this),
      $target = $this.prev();
  $(window).on("scroll", function(){
    if($this.isInViewport() && $target.length > 0){
      $target.addClass("h-animation");
      $this.addClass("v-animation");
    }
  });
});*/

  // video onplace
  Video_onPlace();
  function Video_onPlace() {
    var vid_id,
      other_provider = false;
    //var $vidModal = document.getElementById('video_popup');
    $("body").on("click", ".video-onplace-trigger", function (e) {
      //console.log('clicked');
      e.preventDefault();
      var $thisBtn = $(this);
      vid_id = $(this).attr("data-video-id");
      var vid_provider = $(this).attr("data-video-provider");
      if (vid_provider == "youtube") {
        var vid_src = "https://www.youtube.com/embed/" + vid_id;
        vid_id =
          '<iframe width="560" height="315" src="' +
          vid_src +
          '?rel=0&autoplay=1&loop=1&mw=500&mh=749&q=70" frameborder="0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      } else if (vid_provider == "vimeo") {
        var vid_src = "https://player.vimeo.com/video/" + vid_id;
        vid_id =
          '<iframe width="560" height="315" src="' +
          vid_src +
          '?autoplay=1&loop=1&autopause=0&mw=500&mh=749&q=70" frameborder="0" allow=autoplay webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      } else if (vid_provider == "other") {
        vid_id = $(this).attr("data-video-id");
      }
      $(".video-popup .video-player").removeClass("ready");
      $thisBtn
        .closest(".video-trigger-holder")
        .find(".iframe-outer-holder")
        .html('<div class="iframe-holder">' + vid_id + "</div>");
      setTimeout(function () {
        $thisBtn
          .closest(".video-trigger-holder")
          .find(".iframe-outer-holder")
          .addClass("loaded");
      }, 250);
    });
    /*$vidModal.addEventListener('hidden.bs.modal', function (e) {
        $('.video-popup .video-player').removeClass("ready");
        $('.video-popup .inner-content').removeClass('loaded');
        $('.video-popup .iframe-holder').remove();
        vid_id = "";
        other_provider = false;
    });*/
    /*$vidModal.addEventListener('show.bs.modal', function (e) {
        $('body').addClass('modal-open');
    });*/
    /*$(".video-popup .modal-body").on('click', function(){
      if(!$(this).hasClass('col-12') && $(this).closest('col-12').length <= 0){
        $(".video-popup .modal-close").trigger('click');
      }
    });*/
  }

  // Video popup
  if ($("#video_popup").length > 0) {
    video_popUp();
  }
  function video_popUp() {
    var vid_id,
      other_provider = false;
    var $vidModal = document.getElementById("video_popup");
    $("body").on("click", "[data-bs-target='#video_popup']", function (e) {
      vid_id = $(this).attr("data-video-id");
      var vid_provider = $(this).attr("data-video-provider");
      if (vid_provider == "youtube") {
        var vid_src = "https://www.youtube.com/embed/" + vid_id;
        vid_id =
          '<iframe width="560" height="315" src="' +
          vid_src +
          '?rel=0&autoplay=1&loop=1&mw=500&mh=749&q=70" frameborder="0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      } else if (vid_provider == "vimeo") {
        var vid_src = "https://player.vimeo.com/video/" + vid_id;
        vid_id =
          '<iframe width="560" height="315" src="' +
          vid_src +
          '?autoplay=1&loop=1&autopause=0&mw=500&mh=749&q=70" frameborder="0" allow=autoplay webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      } else if (vid_provider == "other") {
        vid_id = $(this).attr("data-video-id");
      }
      $(".video-popup .video-player").removeClass("ready");
      $(".video-popup .inner-content").html(
        '<div class="iframe-holder">' + vid_id + "</div>",
      );
      setTimeout(function () {
        $(".video-popup .inner-content").addClass("loaded");
      }, 750);
    });
    $vidModal.addEventListener("hidden.bs.modal", function (e) {
      $(".video-popup .video-player").removeClass("ready");
      $(".video-popup .inner-content").removeClass("loaded");
      $(".video-popup .iframe-holder").remove();
      vid_id = "";
      other_provider = false;
    });
    $vidModal.addEventListener("show.bs.modal", function (e) {
      $("body").addClass("modal-open");
    });
    $(".video-popup .modal-body").on("click", function () {
      if (
        !$(this).hasClass("col-12") &&
        $(this).closest("col-12").length <= 0
      ) {
        $(".video-popup .modal-close").trigger("click");
      }
    });
  }

  if (
    $(".article-share-holder").length > 0 &&
    !($("body").hasClass("is-tablet") || $("body").hasClass("is-mobile"))
  ) {
    article_shareHolder();
  }
  function article_shareHolder() {
    var $intro = $(".block-article-intro"),
      $introLength = $intro.length - 1,
      //$tags = $('.block-tags'), tagsL,
      $cta_ = $(".block-large-cta"),
      ctaL,
      $news = $(".block-related-stories"),
      newsL,
      $footer = $("footer"),
      footerL,
      share_dev = $(".article-share-holder");

    let $endSec;

    if ($news.length > 0 || $cta_.length > 0) {
      let arr = [$news.index(), $cta_.index()];
      var removeItem = -1;
      arr = jQuery.grep(arr, function (value) {
        return value != removeItem;
      });

      $endSec = $("section").eq(Math.min.apply(Math, arr));
    } else {
      $endSec = $footer;
    }

    let $startTop, $start, $end, $endTop;
    function calc__() {
      $startTop = $intro.height() + 100.19;
      $start =
        $intro.height() +
        $intro.offset().top -
        $(window).height() +
        share_dev.height() * 2 +
        100 -
        80;
      $end = $endSec.offset().top - $(window).height() + share_dev.height() / 2; //- $endSec.height();
      $endTop = $endSec.offset().top - 140 - share_dev.height() + 101.19; //- 100 - $endSec.height() + 70;
      share_dev.css({ top: "" + $startTop + "px" });
      if ($(window).scrollTop() < $start) {
        share_dev.css({ top: "" + $startTop + "px" });
        share_dev.removeClass("fixed");
      } else if (
        $(window).scrollTop() > $start &&
        $(window).scrollTop() < $end
      ) {
        share_dev.addClass("fixed");
      } else if ($(window).scrollTop() > $end) {
        share_dev.removeClass("fixed");
        share_dev.css({ top: "" + $endTop + "px" });
      }
    }
    calc__();

    $(window).scroll(function () {
      calc__();
    });
  }

  //update articles count in intro one
  if (
    $("section.block-intro-one").length > 0 &&
    $("section.block-latest-articles-grouped div.topics-holder").length > 0
  ) {
    var total_topic_articles = 0;
    $("section.block-latest-articles-grouped").each(function () {
      if ($(this).find("div.topics-holder").data("total-grouped-articles")) {
        total_topic_articles += parseInt(
          $(this).find("div.topics-holder").data("total-grouped-articles"),
        );
      }
    });
    var articles_word = "Article";
    if (total_topic_articles > 1) {
      articles_word = "Articles";
    }
    $("section.block-intro-one a.scroll-to").text(
      total_topic_articles + " " + articles_word,
    );
  }

  $(".scroll-to").click(function (e) {
    e.preventDefault();
    let $btn = $(this);
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $($btn.attr("href")).offset().top,
        },
        400,
      );
    });
  });

  $(".block-latest-articles-grouped").each(function () {
    var $block = $(this);
    if ($block.next().hasClass("block-latest-articles-grouped")) {
      $block.addClass("no-border-bottom");
    }
  });

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function handle_pagination_listener() {
    $(".pagination-holder .pagination a:not(.disabled):not(.active)").on(
      "click",
      function (e) {
        e.preventDefault();
        var href = $(this).attr("href");
        if (href.indexOf("?paged") >= 0) {
          var target_page = getParameterByName("paged", href);
        } else if (href.indexOf("/page/") >= 0) {
          var split_path = href.split("/page/"),
            target_page = split_path[1];
          if (target_page.indexOf("/") >= 0) {
            target_page = target_page.replace("/", "");
          }
        }

        var $pathname = window.location.pathname;
        var page_path = "/page/" + target_page;
        if ($pathname.indexOf("/page/") > -1) {
          $pathname = $pathname.split("/page/");
          window.history.pushState(null, null, $pathname[0] + page_path);
        } else {
          if ($pathname.charAt($pathname.length - 1) == "/") {
            page_path = "page/" + target_page;
          }
          window.history.pushState(null, null, $pathname + page_path);
        }
        var data_type = $(".pagination-holder #pagination-data").data("type");
        if (data_type == "tag") {
          get_more_tagged_articles(target_page);
        } else if (data_type == "search") {
          get_more_search(target_page);
        }

        return false;
      },
    );
  }

  //tags archive page
  if ($("body").hasClass("tag")) {
    handle_pagination_listener();
    function get_more_tagged_articles(target_page) {
      // Check if globalAjax is available
      if (typeof globalAjax === "undefined") {
        console.warn("globalAjax not available for tagged articles");
        return false;
      }

      var ajax_param = {},
        block_obj = $(".block-two-columns-articles-list");
      ajax_param.action = "get_tagged_posts";
      ajax_param._nonce = globalAjax.nonce;
      ajax_param.target_page = target_page;
      ajax_param.tag_term_id = block_obj.data("term-id");
      ajax_param.exclude_posts = block_obj.data("exclude");

      $.ajax({
        url: globalAjax.ajaxurl,
        method: "post",
        dataType: "json",
        data: ajax_param,
        success: function (response) {
          block_obj.find(".pagination-holder").remove();
          if (response.type != "error") {
            block_obj.find(".items-holder .row").html(response.msg);
            if (response.pagination) {
              block_obj.find(".container").after(response.pagination);
              handle_pagination_listener();
            }

            $("html, body").animate(
              {
                scrollTop: block_obj.find(".items-holder .row").offset().top,
              },
              1000,
            );
          } else {
          }
        },
        error: function (error) {},
      });
      return false;
    }
  }

  if ($("body").hasClass("search-results")) {
    handle_pagination_listener();
    localStorage.setItem("sort_type", "relevance");

    $("form.search-form").on("submit", function (e) {
      e.preventDefault();
      get_more_search(1);
      return false;
    });

    $(document).on("click", "#sortBtnApply", function (e) {
      e.preventDefault();
      var sort_type = $('input[name="sort_type"]:checked').attr("id");
      localStorage.setItem("sort_type", sort_type);
      get_more_search(1);
      return false;
    });

    $("#dd_sort_type").on("change", function (e) {
      e.preventDefault();
      var sort_type = $(this).val();
      localStorage.setItem("sort_type", sort_type);
      get_more_search(1, sort_type);
      return false;
    });
  }

  function get_more_search(target_page, sort_type) {
    // Check if globalAjax is available
    if (typeof globalAjax === "undefined") {
      console.warn("globalAjax not available for search");
      return false;
    }

    var ajax_param = {},
      block_obj = $(".block-search-results");
    ajax_param.action = "get_more_search_results";
    ajax_param._nonce = globalAjax.nonce;
    ajax_param.target_page = target_page;
    ajax_param.srch_key = $.trim($("form.search-form input#srch_key").val());
    if (ajax_param.srch_key == "") {
      return;
    }
    if (localStorage.getItem("sort_type")) {
      ajax_param.sort_type = localStorage.getItem("sort_type");
    }

    $.ajax({
      url: globalAjax.ajaxurl,
      method: "post",
      dataType: "json",
      data: ajax_param,
      success: function (response) {
        // console.log(response);

        if (target_page == 1) {
          $("#search_count_msg").html(response.count_html);
        }
        block_obj.find(".pagination-holder").remove();
        if (response.type != "error") {
          block_obj.find(".search-results-row").html(response.msg);
          if (response.pagination) {
            block_obj.find(".container").after(response.pagination);
            handle_pagination_listener();
          }
        } else {
          block_obj.find(".search-results-row").html(response.msg);
        }

        $("html, body").animate(
          {
            scrollTop: block_obj.find(".search-results-row").offset().top - 80,
          },
          1000,
        );

        if (sort_type != null);
        {
          switch (sort_type) {
            case "asc":
              sort_type = "oldest";
              break;
            case "desc":
              sort_type = "newest";
              break;
            case "desc":
              sort_type = "newest";
              break;
          }
          history.replaceState(
            "",
            "",
            "/search/" + ajax_param.srch_key + "?sort=" + sort_type,
          );
          // window.history.replaceState("", "", "/search/"+ajax_param.srch_key+"&sortby="+sort_type);
        }
      },
      error: function (error) {},
    });
    return false;
  }
});

// Scrollbar width calculation
function getScrollbarWidth() {
  // Create measurement element
  const scrollDiv = document.createElement("div");
  scrollDiv.className = "scrollbar-measure";
  scrollDiv.style.cssText = `
    width: 100px;
    height: 100px;
    overflow: scroll;
    position: absolute;
    top: -9999px;
  `;
  document.body.appendChild(scrollDiv);

  // Calculate width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Clean up
  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}

// Logo scale calculation
function calculateLogoScale() {
  const logo = document.querySelector(".logo");
  const container = document.querySelector(".logo-container"); // or whatever contains the logo

  if (!logo || !container) return 1.0;

  const logoWidth = logo.offsetWidth;
  const logoHeight = logo.offsetHeight;
  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;

  return Math.min(containerWidth / logoWidth, containerHeight / logoHeight);
}

// Set CSS custom properties
function setCSSVariables() {
  const scrollbarWidth = getScrollbarWidth();
  const logoScale = calculateLogoScale();

  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${scrollbarWidth}px`,
  );
  document.documentElement.style.setProperty("--logo-scale", logoScale);
}

// Run on load and resize
window.addEventListener("load", setCSSVariables);
window.addEventListener("resize", setCSSVariables);
